/* @ngInject */
export default function ($scope, $stateParams, LayoutService, toastr, $state, Forms, DataTablesService, moment) {
	$scope.formId     = $stateParams.formId;
	$scope.responseId = $stateParams.responseId;

	$scope.loading = true;

	$scope.moment = moment;

	$scope.refresh = () => {
		$scope.loading = true;

		Forms.one($scope.formId)
		     .get({
			     include: 'responses.user.workable,responses.version',
		     })
		     .then((form) => {
			     $scope.form = form;
			     $scope.loading  = false;

			     $scope.updateLayout($scope.form.title);
		     })
		     .catch((error) => {
			     toastr.clear();
			     toastr.error('There was an error while loading the form responses, please try again.', 'Error');

			     $state.go('staff.forms.responses.root');

			     $scope.loading = false;
		     });
	};

	$scope.updateLayout = (formName = 'Loading...') => {
		$scope.dtOptions = DataTablesService.configure({
			title: formName,
		}, {
			order: [
				[
					3,
					'desc',
				],
			],
		}).options;

		LayoutService.reset();

		LayoutService.setTitle([
			formName,
			'Responses',
			'Forms',
		]);

		LayoutService.getPageHeader()
		             .setBreadcrumbs([
			             {
				             route:       'staff.dashboard',
				             displayName: 'Dashboard',
			             },
			             {
				             route:       'staff.forms.root',
				             displayName: 'Forms',
			             },
			             {
				             route:       'staff.forms.responses.root',
				             displayName: 'Responses',
			             },
			             {
				             route:       `staff.forms.responses.view.root({ formId: "${$scope.formId}" })`,
				             displayName: formName,
			             },
		             ]);

		LayoutService.getPageHeader()
		             .setActionButton('<button type="button" class="btn btn-primary pull-right"><i class="fa fa-sync-alt"></i> Update</button>');

		LayoutService.getPageHeader()
		             .onClicked($scope.refresh);
	};

	$scope.updateLayout();
	$scope.refresh();
};


// WEBPACK FOOTER //
// ./src/js/endpoints/staff/forms/responses/view/root/controller.js